<div class="card h-100">
  <div class="card-header border-0 bg-transparent p-3">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h5 class="card-title mb-0">Critical Vulnerability Aging</h5>
        <div class="d-flex align-items-center mt-2">
          <span class="badge bg-danger me-2">CVE ≥ 9.0</span>
          <span class="text-muted small">
            {{ criticalVulnerabilityAgingResponse().totalCriticalVulnerabilities }} Total Vulnerabilities
          </span>
        </div>
      </div>
      <div class="d-flex align-items-center gap-2">
        <div class="last-updated-indicator">
          <small class="text-muted">
            <span style="color: #64748b; font-weight: 400">Last updated:</span>
            {{ criticalVulnerabilityAgingResponse().last_fetch_datetime | date: 'short' }}
          </small>
        </div>
        <kendo-dropdownbutton
          kendoButton
          [svgIcon]="moreVerticalIcon"
          fillMode="flat"
          size="small"
          [data]="[{ text: 'View Data' }]"
          (itemClick)="onViewData()"
        ></kendo-dropdownbutton>
      </div>
    </div>
  </div>
  <div class="card-body pt-2">
    <!-- Age Distribution -->
    <div class="aging-minimal mb-4">
      @for (ageRange of criticalVulnerabilityAgingResponse().ageRanges; track ageRange.range) {
        <div class="aging-row">
          <div class="aging-label">
            <div class="d-flex align-items-center">
              <span
                class="status-dot"
                [class]="ageRange.color"
              ></span>
              <span class="label-text">{{ ageRange.range }}</span>
            </div>
            <span class="count-badge">{{ ageRange.count }}</span>
          </div>
          <div class="aging-bar-wrapper">
            <div class="aging-bar">
              <div
                class="bar-fill"
                [class]="ageRange.color"
                [style.width.%]="ageRange.percentage"
              ></div>
            </div>
            <div class="aging-stats">
              <span class="percentage">{{ ageRange.percentage }}%</span>
              <kendo-chip
                size="small"
                [label]="ageRange.patchable + ' Patchable'"
                [themeColor]="getChipThemeColor(ageRange.color)"
              ></kendo-chip>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

@if (showPopup()) {
  <kendo-dialog
    (close)="close()"
    [width]="'95vw'"
    [height]="'90vh'"
    [minWidth]="'800px'"
    [maxWidth]="'1400px'"
  >
    <kendo-dialog-titlebar>Critical Vulnerability Aging</kendo-dialog-titlebar>

    @if (datatableUrl(); as url) {
      <div class="table-responsive w-100">
        <app-datatable [data-href]="url" [columns]="datatableColumns" [useOData]="true"></app-datatable>
      </div>
    }
  </kendo-dialog>
}
